<script>
    import error from "./stores/error";
</script>

    <div class="error-message" class:visible={$error.visible}>
        {@html $error.message}
    </div>

<style>
    .error-message.visible {
        transform: translateX(-50%) translateY(0);
    }
    .error-message {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%) translateY(-100%);
        transition: .2s;
        color: #fff;
        background: red;
        border-radius: 4px;
        padding: 0 20px;
        z-index: 9999;
        width: max-content;
        max-width: 80%;
    }

    @media (max-width: 575px) {
        .error-message {
            text-align: center;
            width: 95%;
            max-width: 95%;
        }
    }
</style>

